export default __webpack_public_path__ + "src/assets/transfer.04c3c12f52c192ad40f71a023fd5f1aa.svg";